import React from "react";

import dynamic from "next/dynamic";

import { ContentLoader } from "@stadium/ui/src/components/loaders/loaders";

import withResponsiveToggle from "@stadium/ui/src/hoc/responsive-toggle";
import ResponsiveContent from "@stadium/ui/src/contexts/responsive-content";
import { UserConfigProvider } from "@stadium/shared/src/contexts/user-config-provider";
import WebHeader from "@stadium/shared/src/components/header/main/web";

const ResponsiveHeader = dynamic(() => import("./main/responsive"), {
  loading: () => <ContentLoader />,
});

const Header = withResponsiveToggle({
  WebView: WebHeader,
  ResponsiveView: ResponsiveHeader,
});

const WrappedHeader = (props) => (
  <ResponsiveContent>
    <UserConfigProvider>
      <Header {...props} />
    </UserConfigProvider>
  </ResponsiveContent>
);

export default WrappedHeader;
